// AuthForm.js
import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config/api';

const AuthForm = ({ onAuthSuccess }) => {
  const [authCode, setAuthCode] = useState('');
  const [authCodes, setAuthCodes] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAuthConfig = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/auth/config`);
        if (!response.ok) {
          throw new Error('Failed to fetch auth config');
        }
        const data = await response.json();
        setAuthCodes(data.authCodes);
        setError(null);
      } catch (err) {
        console.error('Auth config fetch error:', err);
        setError('Failed to load authentication configuration');
      } finally {
        setLoading(false);
      }
    };

    fetchAuthConfig();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!authCodes) return;

    if (authCode === authCodes.default) {
      onAuthSuccess();
    } else if (authCode === authCodes.admin) {
      onAuthSuccess('admin');
    } else if (authCode === authCodes.viewer) {
      onAuthSuccess('viewer');
    } else {
      alert('Authentication code is incorrect.');
    }
  };

  if (loading) {
    return (
      <div className="container mt-5">
        <div className="card card-body text-center">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5">
        <div className="card card-body text-center">
          <p className="text-danger">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <form onSubmit={handleSubmit} className="card card-body">
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            value={authCode}
            onChange={(e) => setAuthCode(e.target.value)}
            placeholder="Authentication code"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">Authentication</button>
      </form>
    </div>
  );
};

export default AuthForm;
